import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'

export const KlarnaPlacementKey = {
  PRODUCT: 'credit-promotion-badge',
  SITEWIDE: 'top-strip-promotion-auto-size',
} as const

export type KlarnaPlacementKey = UnionOfPropertyTypes<typeof KlarnaPlacementKey>
